import { Dependencies } from "../../../interfaces/dependencies-types";
import * as Pixel from '@serviceos/interaction-pixel/dist';
import { OptionsService } from '../../../services/options-service';
import DependenciesInjector from '../../../helpers/dependencies-injector';

export class interactionController implements Dependencies {
      private interaction: Pixel.InteractionController;
      private optionsService: OptionsService;
      private apiUrl = '';
      private application = '';

      constructor() {}

      async initialize() {
        this.optionsService = await DependenciesInjector.getRegistered('OptionsService');

        //TODO FIX THAT API URL!!!!!
        this.apiUrl = this.optionsService.getObfClientSettings()?.api_url ? 
        this.optionsService.getObfClientSettings().api_url + 'api/v2/system/interactions' : 
        "https://login.fantasticxrm.com/api/v2/system/interactions";

        this.application = this.optionsService.getObfClientSettings().key;

        Pixel.init({
          enablePostPixel: false,
          pixelEndpoint: this.apiUrl,
          application: this.application,
          debug: false
        });

        this.interaction = new Pixel.InteractionController(window,document);

      }

      public tag(method,value,optional?) {
        this.interaction.tag(method,value,optional);
      }

}
